export const TOUR_TRACKS = [
  { id: 'opd', host: 'shifa.his.example' },
  { id: 'ipd', host: 'shifa.his.example' },
  { id: 'lab', host: 'noor-lab.his.example' },
  { id: 'store', host: 'shifa-store.his.example' },
] as const;

export type TourTrackId = (typeof TOUR_TRACKS)[number]['id'];

export const TOUR_CHAPTERS = [
  { id: 'o-start', track: 'opd' },
  { id: 'o-patients', track: 'opd' },
  { id: 'o-clinic', track: 'opd' },
  { id: 'o-billing', track: 'opd' },
  { id: 'o-reports', track: 'opd' },
  { id: 'i-admit', track: 'ipd' },
  { id: 'i-care', track: 'ipd' },
  { id: 'i-discharge', track: 'ipd' },
  { id: 'l-start', track: 'lab' },
  { id: 'l-orders', track: 'lab' },
  { id: 'l-bench', track: 'lab' },
  { id: 's-start', track: 'store' },
  { id: 's-stock', track: 'store' },
  { id: 's-sales', track: 'store' },
] as const satisfies readonly { id: string; track: TourTrackId }[];

export type TourChapterId = (typeof TOUR_CHAPTERS)[number]['id'];

export function chaptersOf(track: TourTrackId): readonly { id: TourChapterId; track: TourTrackId }[] {
  return TOUR_CHAPTERS.filter((chapter) => chapter.track === track);
}
